import { render, staticRenderFns } from "./AlertMessageModal.vue?vue&type=template&id=253a6c08&scoped=true"
import script from "./AlertMessageModal.vue?vue&type=script&lang=js"
export * from "./AlertMessageModal.vue?vue&type=script&lang=js"
import style0 from "./AlertMessageModal.vue?vue&type=style&index=0&id=253a6c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a6c08",
  null
  
)

export default component.exports